import Axios from "axios";
import type { ExtraLayer } from "src/types/extra-layers";

export async function fetchExtraLayers() {
  return await new Promise((resolve) => setTimeout(resolve, 1000)).then(async () => {
    const response = await Axios.get<ExtraLayer[]>("/planning-api/layers/extra");
    return response.data;
  });
}
